import { createFileRoute } from '@tanstack/react-router';
import { ReceiptsPage } from '../features/receipts/ReceiptsPage';
import { validateMonthSearch } from '../lib/months';

export const Route = createFileRoute('/receipts')({
  validateSearch: validateMonthSearch,
  component: ReceiptsPage,
});
